import script from "./RestoreDevices.vue?vue&type=script&setup=true&lang=js"
export * from "./RestoreDevices.vue?vue&type=script&setup=true&lang=js"

import "./RestoreDevices.vue?vue&type=style&index=0&id=19f29fb8&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-19f29fb8"]])

export default __exports__